import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import {
  Project,
  projectUserRole,
  setHeaderTitle,
  showDropdown,
} from 'redux/projectSlice';
import { useGetProjectByIdMutation } from 'redux/services/project';

export const useSetDropdownAndRole = (header = true) => {
  const [project, setProject] = useState<Project | null>(null);
  const { projectId } = useParams();
  const dispatch = useDispatch();
  const [getProjectById, { data, isLoading }] = useGetProjectByIdMutation();

  const fetchProjectDetails = () => {
    getProjectById(projectId);
  };

  useEffect(() => {
    if (projectId) {
      getProjectById(projectId);
    }
  }, [getProjectById, projectId]);

  useEffect(() => {
    if (projectId) {
      dispatch(showDropdown(true));
      if (data) {
        dispatch(projectUserRole(data.role));
        setProject(data);
        if (header) {
          dispatch(
            setHeaderTitle({
              title: data.projectInfo.projectName,
              subTitle: data.projectInfo.projectId,
            }),
          );
        } else {
          dispatch(setHeaderTitle(null));
        }
      }
    } else {
      dispatch(showDropdown(false));
      dispatch(setHeaderTitle(null));
    }

    return () => {
      dispatch(showDropdown(false));
    };
  }, [data, header, dispatch, projectId]);

  return {
    project,
    isLoading,
    fetchProjectDetails,
  };
};
